module.exports = __webpack_public_path__ + "static/img/photo.e769cd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photo.jpg
// module id = 7Zem
// module chunks = 0